import { hc } from "hono/client"
import type { App } from "@server/app"

/**
 * Typed API client. All request/response types are inferred from the
 * server's zod-openapi routes. e.g.:
 *
 *   const res = await client.api.notes.$get()
 *   const body = await res.json() // { data: Note[] }
 *
 *   const res = await client.api.notes[":id"].$patch({
 *     param: { id: "..." },
 *     json: { title: "updated" },
 *   })
 */
export const client = hc<App>(window.location.origin)
